module.exports = __webpack_public_path__ + "static/wyobrazone_vector-9a4bff76c9a87ae19599b780bce63f4b.svg";